export default {
  groups: (state, getters) => {
    return state.groups
  },
  parents: (state, getters) => {
    return state.parents
  },
  bulkUsers: (state, getters) => {
    return state.bulkUsers
  },
  activeGroup: (state, getters) => {
    return state.activeGroup
  },
  group: (state, getters) => {
    return getters.groups.data.find(g => g._id === getters.activeGroup)
  }
}



// WEBPACK FOOTER //
// ./src/app/store/groups/getters.js